import { SnackbarProvider, useSnackbar } from "notistack";
import { DefaultToast } from "./ToastTypes/DefaultToast";

export const useNotifications = () => {
  const { enqueueSnackbar } = useSnackbar();

  return {
    notify: enqueueSnackbar,
  };
};

type Props = { children: React.ReactNode };

export function ToastProvider({ children }: Props) {
  return (
    <SnackbarProvider
      Components={{
        default: DefaultToast,
      }}
      maxSnack={2}
      anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      autoHideDuration={5000}
    >
      {children}
    </SnackbarProvider>
  );
}
